import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import SectionHeader from "@/components/SectionHeader";
import { Calendar, Tag } from "lucide-react";

export default function News() {
  const [posts, setPosts] = useState([]);
  const [active, setActive] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/news")
      .then((res) => setPosts(res.data))
      .finally(() => setLoading(false));
  }, []);

  const formatDate = () => "";

  return (
    <div className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeader
          eyebrow="News & Updates"
          title="What's Happening in South Lebanon."
          intro="Ribbon cuttings, community events, and updates from the mayor's office and the campaign trail."
        />

        {loading && <p className="text-muted-foreground">Loading updates…</p>}

        {!loading && posts.length === 0 && (
          <div className="border border-border bg-card p-10 text-center" data-testid="news-empty">
            <p className="text-muted-foreground">No updates yet — check back soon.</p>
          </div>
        )}

        {active ? (
          <article className="bg-card border border-border p-8 md:p-12" data-testid="news-detail">
            <button
              className="text-sm uppercase tracking-wider text-accent font-bold mb-6 hover:underline"
              onClick={() => setActive(null)}
              data-testid="news-back-button"
            >
              ← Back to all updates
            </button>
            {active.image_url && (
              <img src={active.image_url} alt={active.title} className="w-full h-72 object-cover mb-8 border border-border" />
            )}
            <div className="flex items-center gap-4 text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground mb-4">
              <span className="flex items-center gap-1.5"><Tag size={12} />{active.category}</span>
            </div>
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-primary leading-tight">{active.title}</h2>
            <p className="mt-6 text-lg text-foreground/85 leading-relaxed whitespace-pre-line">{active.body}</p>
          </article>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="news-grid">
            {posts.map((post) => (
              <article
                key={post.id}
                data-testid="news-card"
                className="bg-card border border-border hover:border-primary transition-colors cursor-pointer group"
                onClick={() => setActive(post)}
              >
                {post.image_url && (
                  <div className="aspect-[16/10] overflow-hidden border-b border-border">
                    <img
                      src={post.image_url}
                      alt={post.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                )}
                <div className="p-6">
                  <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.22em] font-bold text-accent mb-3">
                    <span>{post.category}</span>
                  </div>
                  <h3 className="font-serif text-xl font-bold text-primary leading-tight mb-3 group-hover:text-accent transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed line-clamp-3">{post.excerpt}</p>
                  <div className="mt-5 text-xs uppercase tracking-[0.22em] font-bold text-primary">
                    Read More →
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
